const COOKIE_NAME = "compaws_auth_hint";
const MAX_AGE = 60 * 60 * 24 * 7; // 7 days

export interface AuthHint {
  userType: "humano" | "compawdre" | null;
  isAdmin: boolean;
}

export function setAuthHintCookie(hint: AuthHint): void {
  const value = JSON.stringify(hint);
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(value)};path=/;max-age=${MAX_AGE};SameSite=Lax`;
}

export function getAuthHintCookie(): AuthHint | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));
  if (!match) return null;
  try {
    return JSON.parse(decodeURIComponent(match[1])) as AuthHint;
  } catch {
    return null;
  }
}

export function clearAuthHintCookie(): void {
  document.cookie = `${COOKIE_NAME}=;path=/;max-age=0`;
}
